import {
  ChakraBox,
  ChakraFlex,
  ChakraTab,
  Counter,
  Text,
} from '@equip.health/ui';

import { PatientTabs } from '~/lib/constants/patients.constants';

interface PatientLayoutTabProps {
  isActive: boolean;
  label: string;
  subPath: string;
  tab: string;
  taskCount: number;
}

const PatientLayoutTab = ({
  isActive,
  label,
  subPath,
  tab,
  taskCount,
}: PatientLayoutTabProps) => (
  <ChakraTab
    _hover={{ borderBottomColor: 'accent.blue' }}
    _selected={{ backgroundColor: 'white', borderColor: 'accent.blue' }}
    display="block"
    key={subPath}
    padding="9px 8px 3px 8px"
  >
    <ChakraFlex alignItems="center" justifyContent="space-between">
      <Text
        color={isActive ? 'neutral.primary' : 'neutral.secondary'}
        variant={isActive ? 'captionMedium' : 'caption'}
      >
        {label}
      </Text>
      {tab === PatientTabs.TASKS && taskCount > 0 && (
        <ChakraBox marginLeft="6px">
          <Counter id="patient-menu__tasks-counter" number={taskCount} />
        </ChakraBox>
      )}
    </ChakraFlex>
  </ChakraTab>
);

export default PatientLayoutTab;
